import React from 'react'
import Manager from '../../public/components/Manager'
import AttendanceRecordDetail from './AttendanceRecordDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        {
            icon: 'share', text: '导入',
            handler: ({ refreshPage }) => Tyan.pubForm.showImport(
                'ImportCheckRecord'/*event name*/,
                'Excel导入'/*对话框标题*/,
                (data) => refreshPage && refreshPage()/*后台处理回调函数, 默认为空，即无需回调，调用前系统会显示导入成功 */,
                /* '.xls,.xlsx'     : 文件后缀，默认为'.xls, .xlsx' */
                /* {}     : 需要传输到后台的事件参数, 默认为空对象{} */
            )
        },
    ],
    columns: [
        { _date: '日期', field: 'CheckDate', minWidth: 250, locked: false, flex: 1, filter: true, align: 'left' },
        { _text: '日期类型', field: '_CheckDateType', minWidth: 150, flex: 1 },
        { _int: '未打卡人数', field: 'NoPunchPeopleNum', minWidth: 150, flex: 1 },
        { _int: '迟到人数', field: 'LatePeopleNum', minWidth: 150, flex: 1 },
        { _int: '早退人数', field: 'EarlyPeopleNum', minWidth: 150, flex: 1 },
        { _int: '缺勤人数', field: 'OutPeopleNum', minWidth: 150, flex: 1 },
        { _int: '外出人数', field: 'AbsenceFromDutyPeopleNum', minWidth: 150, flex: 1 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <AttendanceRecordDetail {...props} id={data.id} />)
    }
}

export default props => <Manager {...props} config={config} />